import React from 'react'
import styles from './unlockedSsnHeader.module.css'
import { Box, Button } from '@mui/material';
import { RightOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import NotUnlockedApplicationIcon from '../../../Components/Icons/notUnlockedApplicationIcon';

interface UnlockedSsnHeaderProps {
    opportunityId: string;
}

export const UnlockedSsnHeader = (props: UnlockedSsnHeaderProps) => {
    const { opportunityId } = props;

    const opportunityUrl = opportunityId ? `/insights/moreInfo?opportunityId=${opportunityId}` : null;

    const handleViewApplication = () => {
        if (opportunityUrl) {
            window.open(opportunityUrl, '_blank', 'noopener,noreferrer');
        } else {
            toast.error('Opportunity URL not found');
        }
    }

    return (
        <Box className={styles.mainOuterCtn}>
            <Box className={styles.leftCtn}>
                <Box className={styles.iconOuterCtn}>
                    <Box className={styles.iconInnerCtn}>
                        <NotUnlockedApplicationIcon />
                    </Box>
                </Box>
            </Box>
            <Box className={styles.rightCtn}>
                <Box className={styles.titleCtn}>
                    <p className={styles.title}>Application Not Locked</p>
                    <p className={styles.description}>This application is not locked because the identity (SSN, Email, and Phone) was unlocked in a previous declined application.</p>
                </Box>
                <Box className={styles.extraInfoOuterCtn}>
                    <Box className={styles.extraInfoInnerCtn}>
                        <p className={styles.extraInfoTitle}>Unlocked Identity Reference Application</p>
                        <p className={styles.extraInfoValue}>{opportunityId}</p>
                    </Box>
                    <Button className={styles.extraInfoButton} endIcon={<RightOutlined className={styles.extraInfoButtonIcon} />} onClick={handleViewApplication}>View Application</Button>
                </Box>
            </Box>
        </Box>
    )
}
